<div class="layout-view">
  <div class="layout-header">
    <app-header></app-header>
  </div>
  <div class="layout-content">
    <h1>Bienvenido/a</h1>
  </div>
  <div class="layout-footer">
    <app-footer></app-footer>
  </div>
</div>


